import React from "react";
import { Box } from "@mui/material";
import AppsLauncher from "./AppsLauncher";
import TopBarProfileAvatar from "./TopBarProfileAvatar";

export default function TopBarRightActions({
  account,
  onOpenProfile,
  showAppsLauncher = true,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: { xs: 0.5, sm: 0.75 },
        flexShrink: 0,
      }}
    >
      <TopBarProfileAvatar account={account} onClick={onOpenProfile} />
      {showAppsLauncher && <AppsLauncher />}
    </Box>
  );
}
